import { render, staticRenderFns } from "./OneTime.vue?vue&type=template&id=70bacb5a&scoped=true&lang=pug&"
import script from "./OneTime.vue?vue&type=script&lang=js&"
export * from "./OneTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bacb5a",
  null
  
)

export default component.exports